import { GoogleReCaptchaProvider as GoogleReCaptchaProviderV3 } from "react-google-recaptcha-v3";

export const GoogleReCaptchaProvider = ({
  children,
  showDisclaimer = true,
}: {
  children: React.ReactNode;
  showDisclaimer?: boolean;
}) => {
  return (
    <GoogleReCaptchaProviderV3
      reCaptchaKey={import.meta.env.REACT_APP_RECAPTCHA_SITE_KEY || ""}
      scriptProps={{
        appendTo: "head",
      }}
    >
      {children}
      {showDisclaimer && (
        <p className="absolute bottom-0 left-1/2 -translate-x-1/2 p-2 text-sm text-gray-300">
          This site is protected by reCAPTCHA and the Google{" "}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noreferrer"
            className="underline"
          >
            Privacy Policy
          </a>{" "}
          and{" "}
          <a
            href="https://policies.google.com/terms"
            target="_blank"
            rel="noreferrer"
            className="underline"
          >
            Terms of Service
          </a>{" "}
          apply.
        </p>
      )}
    </GoogleReCaptchaProviderV3>
  );
};
